import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SfIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M18.4175 3.38991L14.4889 2.51078C14.4065 2.4833 14.3241 2.51078 14.2691 2.56572C14.2142 2.62067 14.1592 2.70309 14.1592 2.78551L14.1318 7.64819L18.6098 7.67566L18.6373 3.66464C18.6373 3.55474 18.5549 3.41738 18.4175 3.38991Z",
                fill: "#FB275D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.118 12.6511L18.5961 12.6675L18.6124 8.21695L14.1343 8.20053L14.118 12.6511Z",
                fill: "#FB275D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.1043 17.2088C14.1043 17.3462 14.2142 17.4835 14.3791 17.4835L18.3077 17.511C18.4725 17.511 18.5824 17.4011 18.5824 17.2363L18.6099 13.2252L14.1318 13.1978L14.1043 17.2088Z",
                fill: "#FB275D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.02747 12.6208L1 17.1813C1 17.3187 1.10989 17.456 1.27473 17.456H2.70331C2.86815 17.456 2.97804 17.3461 2.97804 17.1813V14.1868L13.5276 14.2142V12.401L1.3022 12.3461C1.13736 12.3461 1.02747 12.456 1.02747 12.6208Z",
                fill: "#FB275D"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.32962 8.49983C1.19226 8.49983 1.02742 8.60972 1.02742 8.77456V11.8515C1.10984 11.824 1.21973 11.7966 1.30215 11.7966H1.57688V10.5328C2.5659 10.5053 3.52745 10.4229 4.48899 10.2856V11.824H5.03845V10.2031C6.02747 10.0383 6.98902 9.81852 7.95057 9.51632V11.8515H8.50002V9.35148C9.48904 9.04928 10.4506 8.66466 11.4121 8.2251V11.879H11.9616L11.9891 7.97784C12.5111 7.73059 13.033 7.45586 13.5825 7.18113V6.54926C13.0605 6.85146 12.5111 7.12619 11.9891 7.37344V5.72508C12.5385 5.25804 13.0605 4.76353 13.5825 4.21407V3.38989C10.3682 7.04377 6.35714 8.71961 1.32962 8.49983ZM4.48899 9.70863C3.52745 9.84599 2.53843 9.95589 1.57688 9.98336V9.07676C2.53843 9.10423 3.49997 9.07676 4.48899 8.93939V9.70863ZM7.97804 8.91192C7.01649 9.21412 6.02747 9.4339 5.06592 9.62621V8.85697C6.08242 8.69214 7.07144 8.41741 8.00551 8.06026L7.97804 8.91192ZM11.4396 7.56575C10.4781 8.00532 9.48904 8.38994 8.5275 8.71961V7.81301C9.54399 7.37344 10.533 6.79651 11.4671 6.10969L11.4396 7.56575Z",
                fill: "#FB275D"
            })
        ]
    });
